import React from "react"
import { FormattedDate, FormattedNumber } from "react-intl"
import { Link } from "react-router-dom"
import SortLink from "../../common/listing/sortlink.component.jsx"
import { Intl } from "../../state/helpers/IntlProps"
import { IMPORT_MESSAGES } from "./messages"


const headerKeys = [
    "productTitleKeyword", 
    "createdAt",
    "initialQuantity",
    "quantity",
    "finalQuantity"
]

export const getHeadersData = (
    sortByField: string,
    sortAsc: boolean,
    handleSortLinkChange: (sortByField: string, sortAsc: boolean) => void,
    intl: Intl
) => {
    return headerKeys.map( key => {
        return <SortLink
            key={key}
            field={key}
            sortField={sortByField}
            asc={sortAsc}
            onChange={handleSortLinkChange}
        >
            {intl.formatMessage(IMPORT_MESSAGES[`header_${key}`])}
        </SortLink>
    })
}


export const getRowCellsData = (importElem ) => {
    return [
        <Link to={"/products/edit/" + importElem.productId} key={`${importElem.id}-productTitleKeyword`}>
            {importElem.productTitleKeyword? importElem.productTitleKeyword : importElem.productId}
        </Link>,
        <FormattedDate
            key={`${importElem.id}-createdAt`}
            year="numeric"
            month="long"
            day="numeric"
            value={new Date(importElem.createdAt)} 
        />,
        <FormattedNumber
            key={`${importElem.id}-initialQuantity`}
            value={new Number(importElem.initialQuantity)} 
        />,
        <>
            {Number(importElem.quantity) && Number(importElem.quantity)>0 && "+"}
            <FormattedNumber
                key={`${importElem.id}-quantity`}
                value={new Number(importElem.quantity)} 
            />
        </>,
        <FormattedNumber
            key={`${importElem.id}-finalQuantity`}
            value={new Number(importElem.finalQuantity)} 
        />,
    ]
}


// WEBPACK FOOTER //
// ./src/utils/inventory/importListingHelper.tsx